import { styled, css } from 'styled-components';

import { Image } from 'src/components/image';
import arrowRightHover from 'src/resources/arrow-right-hover.svg';
import arrowRight from 'src/resources/arrow-right.svg';
import { breakpointTablet } from 'src/styles/breakpoints';
import { colorSecondary200, colorSecondary300, colorSecondary900 } from 'src/styles/colors';
import { focus } from 'src/styles/mixins';
import { spacing1, spacing3 } from 'src/styles/spacing';

interface StyledNavigationProps {
  $active: boolean;
}

export const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  max-height: 176px;

  @media (min-width: ${breakpointTablet}) {
    max-height: 284px;
  }
`;

export const StyledImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 1 auto;
`;

export const StyledPicture = styled(Image)`
  object-fit: contain;
  width: 100%;
  max-height: 136px;

  @media (min-width: ${breakpointTablet}) {
    max-height: 261px;
  }
`;

export const StyledImageWrapper = styled.div`
  margin: 0 auto ${spacing3};
`;

export const StyledArrowColumn = styled.div`
  flex: 0 0 20px;
`;

export const StyledArrowRight = styled.button`
  height: 20px;
  width: 20px;
  background: url(${arrowRight}) no-repeat center;
  border: 0;

  &:hover {
    background: url(${arrowRightHover}) no-repeat center;
    cursor: pointer;
  }

  ${focus};
`;

export const StyledArrowLeft = styled(StyledArrowRight)`
  transform: rotate(180deg);
`;

export const StyledNavigationRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const StyledNavigationItem = styled.button<StyledNavigationProps>`
  flex: 1 1 auto;
  cursor: pointer;
  margin-right: ${spacing1};
  padding: 0;
  border: 0;
  border-radius: 8px;
  background: ${colorSecondary200};
  height: 5px;

  &:last-child {
    margin-right: 0;
  }

  &:hover {
    background: ${colorSecondary300};
  }

  ${focus};
  ${({ $active }) => $active && stylesActiveNavigationItem};
`;

const stylesActiveNavigationItem = css`
  background: ${colorSecondary900};

  &:hover {
    background: ${colorSecondary900};
  }
`;

export const StyledImage = styled(Image)`
  width: 100%;
`;
